/*
* Salla Product Availability Component: popup modal to notify user if the product is available,
* used in the product single page if the product isn't available.
* You can use these classes to target the elements in the component.
*/
.s-product-availability {
  &-wrap {

  }
  &-subscribed {

  }

  &-subs-icon {

  }

  &-body {

  }

  &-label {

  }

  &-input {

  }

  &-footer {

  }

  &-footer-btn {

  }

  &-error-msg {

  }
}
